<template>

	<div >
		<b-overlay :show="payslip_loader" no-center class="payslip-employee-overlay">
			<template #overlay>
				<div class="position-absolute" style="left: 0; right: 0; top: 100px; text-align: center;">
					<span aria-hidden="true" class="spinner-border"></span>
				</div>
			</template>
			<div class="payslip-page">

			<form @submit="formSubmit" enctype="multipart/form-data">
			<input class="input" type="hidden" v-model="fdata.id" >
			<input class="input" type="hidden" v-model="employee_id" >
			<input class="input" type="hidden" v-model="fiscal_year" >
			<input class="input" type="hidden" v-model="from_date" >
			<input class="input" type="hidden" v-model="to_date" >
			<input class="input" type="hidden" v-model="pay_slip_ref" >
			<input class="input" type="hidden" v-model="pay_slip_name" >


			<div class="row ">
				<div class="col-md-12 action-button pr-5">
					<b-overlay :show="action_loader" rounded="sm">
						<!-- <b-button class="border rounded bg-light float-right py-1 px-2 mt-4 ml-2" type="submit" variant="primary" @click="downloadPaySlip(payslip,fiscal_year,'','true')"><i class="fas fa-print px-1" aria-hidden="true" style="font-size:16px;"></i> Print</b-button> -->
						<b-button class="border rounded bg-light float-right py-1 px-2 ml-2 " type="submit" variant="primary" @click="downloadPaySlip(payslip,fiscal_year)">Download PDF</b-button>
						<b-button class="border rounded bg-light float-right py-1 px-2 ml-2 custom-primary" type="submit" variant="primary" @click="downloadPaySlip(payslip,fiscal_year,'true','')"><i class="far fa-envelope px-1" aria-hidden="true" style="font-size:16px;"></i> Email</b-button>

					</b-overlay>
			</div>
			</div>
			<div class="row payslip-details-card">
			<div class="col-md-12 text-center pay-slip-title">
				<p  class="first">{{company_name}}</p>
				<p class="second"> {{payslip_title}}</p>
				<p class="third"> Income Year {{fiscal_year}}</p>
			</div>
			</div>

			<div class="row payslip-details-card">

			<div class="col-md-12 payslip-details-info">

				<div class="row payslip-details-info-inner">
					<template v-for="(row, index) in dynamic_fields">

						<div class="col-md-6 payslip-details-info-right">
							<template  v-if="row.header_left_name != ''">
								<div class="wrapper">
								<div class='first' :key="index" >{{row.header_left_name}}</div>
								<div class='second'>
									<template  v-if="row.header_left_name == 'Month'">
										{{pmonth+' '+pyear}}
									</template>
									<template  v-if="row.header_left_value == '0000-00-00'">
										N/A
									</template>
									<template v-else>
										<template v-if="row.header_left_value == ''">Not Available</template><template v-else>{{row.header_left_value}}</template>
									</template>


								</div>
								</div>
							</template>
						</div>

						<div class="col-md-6 payslip-details-info-right">
							<template  v-if="row.header_right_name != ''">
								<div class="wrapper">
								<div class='first'>{{row.header_right_name}}</div>
									<div class='second'>
										<template  v-if="row.header_right_name == 'Month'">
											{{pmonth+' '+pyear}}
										</template>
										<template  v-if="row.header_right_value == '0000-00-00'">
											N/A
										</template>
										<template v-else>
											<template  v-if="row.header_right_name != 'Month'">
												<template v-if="row.header_right_value == ''">Not Available</template><template v-else>{{row.header_right_value}}</template>
											</template>
										</template>

									</div>
								</div>
							</template>

						</div>
					</template>
				</div>
			</div>
			</div>

			<div class="row payslip-details-card">
                <!-- Abdullah 19-05-26 added this  -->
			<div class="col-md-12 payslip-income-mobile pr-0">
				<div class="payslip-details-title">Income Details</div>

				<table class="table table-bordered">
					<tbody class="slip-details-table">
						<tr class="table-head"><td>Gross Salary</td><td class="text-center">Amount (BDT)</td></tr> <!-- Mustafijur: 19-05-2026 -->
						<template v-if="pre_gross_flag == 1">
							<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1' && salaryhead.field_key != 'basic_salary' && salaryhead.field_key != 'house_rent' && salaryhead.field_key != 'conveyance_allowance' && salaryhead.field_key != 'medical_allowance'">
								<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
							</tr>
						</template>
						<template v-else>
							<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1'">
								<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
							</tr>
						</template>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset == 'custom_gross_salary_components') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset == 'pre_adhoc_deduction' || salaryhead.displayset == 'pre_deduction_incremental_hours' || salaryhead.displayset == 'pre_deduction_incremental_days' || salaryhead.displayset == 'pre_deduction_fixed' || salaryhead.displayset == 'pre_deduction_manual') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">({{salaryhead.value}})</td>
						</tr>

						<template v-if="pre_gross_flag == 1">
						<tr class="table-head" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Salary Without Additions'"><td>Total Gross Salary</td><td style="text-align: right;">{{salaryhead.value}}</td></tr>
						</template>
						<template v-else>
						<tr class="table-head" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Salary Without Additions'"><td>Total Gross Salary</td><td style="text-align: right;">{{salaryhead.value}}</td></tr>
						</template>
				</tbody>
				</table>

				<table class="table">
			<tbody>
						<tr class="table-head"><td>Other Benefits &amp; Allowances </td><td class="text-center">Amount (BDT)</td></tr> <!-- Mustafijur: 19-05-2026 -->

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.1' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>


						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '2' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset=='overtime_holiday_manual' || salaryhead.displayset=='overtime_holiday_incremental_days' || salaryhead.displayset=='overtime_holiday_fixed' || salaryhead.displayset=='overtime_holiday_incremental_hours') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset=='overtime_holiday_manual_non_taxable' || salaryhead.displayset=='overtime_holiday_fixed_non_taxable' || salaryhead.displayset=='overtime_holiday_incremental_days_non_taxable' || salaryhead.displayset=='overtime_holiday_incremental_hours_non_taxable') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc_nontax'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset=='contracted_variable_payslip') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Basic Salary'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>


						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Medical Allowance'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>


						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Conveyance Allowance'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>


						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear House Rent Allowance'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'custom_gross_salary_components_arrear'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear PF Contribution'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>


						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'off_cycle_adhocs'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Display Loan in Payslip' && salaryhead.displayset == 'display_loan_in_payslip'">
						<td>Loan/Advance Distributed</td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Display PF Loan in Payslip' && salaryhead.displayset == 'display_pf_loan_in_payslip'">
						<td>PF Loan Distributed</td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

					<tr class="table-head" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Total Additions'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>Total Other Benefits &amp; Allowances</td>
						<!-- <td style="text-align: right;"><template v-if="decimal_setting == 'no'">{{moneyFormat(Math.round(total_other))}}</template><template v-else>{{moneyFormat(total_other.toFixed(2))}}</template></td> -->
						<td style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Gross Pay'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'" class="table-head blue-head">
						<!-- <td class="font-weight-bold"> Total Earnings </td><td  style="text-align: right;">{{moneyFormat(contribution.toFixed(2))}}</td> -->
						<td class="font-weight-bold"> Total Earnings </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>
					</tbody>
				</table>

				<table class="table">
					<tbody>

						<tr class="table-head"><td>Deductions</td><td class="text-center">Amount (BDT)</td></tr> <!-- Mustafijur: 19-05-2026 -->

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Employer\'s Contribution to PF' && salaryhead.value!='-0' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>Employer's Contribution to PF</td> <td style="text-align: right;">({{salaryhead.value}}) </td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Employer\'s Contribution to PF' && salaryhead.value!='-0' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>Arrear PF Employer's Contribution</td> <td style="text-align: right;">({{salaryhead.value}}) </td>
						</tr>

						<template v-if="tax_policy_flag">
							<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '5'  && salaryhead.value!='-0' && salaryhead.head!='AIT Surplus' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00' && salaryhead.head!='Income Tax' && salaryhead.head!='Monthly Tax' && salaryhead.head!='One-off Tax Deduct' && salaryhead.head!='One-off Tax'">
							<td>{{salaryhead.head}}</td> <td style="text-align: right;">({{salaryhead.value}})</td>
							</tr>
						</template>

						<template v-else>
							<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '5'  && salaryhead.value!='-0' && salaryhead.head!='AIT Surplus' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
							<td>{{salaryhead.head}}</td> <td style="text-align: right;">({{salaryhead.value}})</td>
							</tr>
						</template>

						<!-- ALI EDIT -->

							<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'for_payslip_deduction'  && salaryhead.value!='-0' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>{{salaryhead.head}}</td> <td style="text-align: right;">({{salaryhead.value}})</td>
						</tr>

						<!-- ALI EDIT  -->

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset == 'adhoc_deduction' || salaryhead.displayset=='post_deduction_manual' || salaryhead.displayset=='post_deduction_fixed' || salaryhead.displayset=='post_deduction_incremental_days' || salaryhead.displayset=='post_deduction_incremental_hours')  && salaryhead.value!='-0' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>{{salaryhead.head}}</td> <td style="text-align: right;">({{salaryhead.value}})</td>
						</tr>

						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear PF Contribution'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>Arreae PF Employer's Contribution</td><td style="text-align: right;">({{salaryhead.value}})</td>
						</tr>




						<tr class="table-row " v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'AIT Adjustment' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>AIT Adjustment</td> <td style="text-align: right;">({{salaryhead.value}})</td>
						</tr>

						<tr class="table-head" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '500' ">
					<!--<td class="font-weight-bold">Total Deductions</td> <td style="text-align: right;">({{Math.abs(parseFloat(salaryhead.value.replace(/\,/g,''))).toLocaleString()}})</td>-->
						<td class="font-weight-bold">Total Deductions</td> <td style="text-align: right;">({{salaryhead.value}})</td>
						</tr>



					</tbody>
				</table>
				<table class="table">
					<tbody>

						<tr class="table-head blue-head" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '7'">
						<td class="font-weight-bold">Net Salary</td> <td style="text-align: right;"><b>{{salaryhead.value}}</b></td>
						</tr>
						<tr class="table-row ">
						<td colspan="2">
						<span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '7'">
						<template>
						<inwords-front  :amount="salaryhead.value"></inwords-front>
						</template>
						</span>
						</td>
						</tr>

				</tbody>
				</table>

				<template v-if="tax_policy_flag">
					<table class="table">
						<tbody>
							<tr class="table-head" v-for="salaryhead in taxinfo" :key="salaryhead.head" v-if="salaryhead.displayset == 'total_tax'">
								<td class="font-weight-bold">Income Tax Paid By Employer</td> <td style="text-align: right;"><b>{{salaryhead.value}}</b></td>
							</tr>
						</tbody>
					</table>
				</template>


				<template v-for="salaryhead in salaryheads">
					<table class="table table-bordered table-hover" v-if="salaryhead.rfa > 0  || salaryhead.cpu > 0 || salaryhead.oncp > 0" :key="salaryhead.head">
						<thead>
							<tr class="table-head" style="font-weight: bold;"><td>Non-Cash Taxable Benefits</td><td class="text-center"></td></tr>
						</thead>
						<tbody class="slip-details-table">

							<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.2'  && salaryhead.head=='Rent-free Accomodation' && salaryhead.rawvalue > 0"><td>Rent-free accommodation</td><td style="text-align: right;">
							<span>{{salaryhead.value}}</span>
							</td></tr>
							<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.2'  && salaryhead.head=='Conveyance for Personal/Private Use' && salaryhead.rawvalue > 0"><td>Conveyance for personal use</td><td style="text-align: right;">
							<span>{{salaryhead.value}}</span>
							</td></tr>
							<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.2'  && salaryhead.head=='Other Non-Cash Perquisites' && salaryhead.rawvalue > 0"><td>Other Perquisites, Allowances and Benefits</td><td style="text-align: right;">
							<span>{{salaryhead.value}}</span>
							</td></tr>

						</tbody>
					</table>
				</template>

			</div>
		</div>


		<div class="row mt-2">
			<div class="col-md-12">
			<p class="mt-5 mb-5 text-center">**Computer generated pay slip does not require signature**</p>
			</div>
		</div>
		</form>
		</div>
		</b-overlay>
	</div>
</template>
<style scoped>
.s-thead{background: #c9c9c9;}
.s-tfoot{background: #e5e5e5;}
.s-section{background: #5b6992;}
</style>

<script>
  export default {
	  mounted() {
		 // console.log('Payslip started..');
		 // console.log(this.componentdata);
	  },
	  props: [ 'payslip','company','payslipname','emp_etin','emp_department','emp_jobposition','emp_code','emp_joining','emp_branch','pmonth','pyear','dynamic_fields'],
	  data() {

		  return {
			  employees : [],
			  salaryheads : [],
			  taxinfo : [],
			  taxdata : [],
			  fiscalyears: [],
			  adhocfields: [],
			  adhocheadsnvalues: [],
			  slabs_and_values : [],
			  fdata: {}, // fix: was [] causing Cannot read properties of null (reading 'id')
			  company_name:this.company,
			  payslip_title: this.payslipname,
			  download_file_name: '',
			  success: '',
			  employee_id: '',
			  fiscal_year: '',
			  from_date: '',
			  to_date: '',
			  pay_slip_ref: '',
			  pay_slip_name: '',
			  month: '',
			  year: '',
			  adhoc_field: '',
			  adhoc_field_value: '',
			  action_loader: false,
			  payslip_loader_text: 'We are preparing the data for this employee.',
    		  payslip_loader : false,
			  pre_gross_flag: 0,
			  tax_policy_flag : false,
		  }
	  },

	  methods:{
			moneyFormat(amount)
			{
				var money = Number(amount);
				money = money.toLocaleString();
				if(money=='NaN')
					money = amount;
				else
					if(this.decimal_setting == 'yes' || this.decimal_setting == ''){
						if(money.indexOf(".")<0)
							money = money+'.00';
					}else{
						money = money;
					}
				return money;
			},
			getInwords: function(txt)
			{


						axios.get(this.$api_url+'/front/getinwords/'+txt , {
							params: {
								page: 1,
								per_page: 10,
								search_query: this.search,
								search_query_by_id: '',
							}
					}).then(function(response){

					return response.data;


				}.bind(this));


			},


			getFiscalyears: function()
			{

						axios.get(this.$api_url+'/front/getfiscalyears' , {
							params: {
								page: 1,
								per_page: 10,
								search_query: this.search,
								search_query_by_id: '',
							}
					}).then(function(response){
					this.fiscalyears = response.data;


				}.bind(this));
			},

			/* getSalaryinfo: function()
			{
				axios.get(this.$api_url+'/salary-slip/'+this.employee_id , {
							params: {
								fiscal_year: this.fiscal_year,
								payslip_id: this.fdata.id,
								output_type: 'merge_report',
								search_query_by_id: '',
							}
					}).then(function(response){
					this.salaryheads = response.data.salary;
					this.slabs_and_values=response.data.slabsnvalues;
					this.taxinfo=response.data.tax;
					this.adhocfields=response.data.adhocfields;
					this.adhocheadsnvalues=response.data.adhocheadsnvalues;

				}.bind(this));
			}, */

		  	getSalaryDataFromDB: function(is_taxcard)
			{

				axios.get(this.$api_url+'/front/salary-slip-db' , {
						  params: {
							  fiscal_year: this.fiscal_year,
							  payslip_id: this.fdata.id,
							  output_type: 'merge_report',
							  is_taxcard: is_taxcard,
							  search_query_by_id: '',
						  }
				  }).then(function(response){

				  this.salaryheads = response.data.salary;
				  /* Added by Sohel starts */
				  this.salaryheads.forEach(element => {

					if(element.field_key == 'basic_salary_before_pregross' || element.field_key == 'house_rent_before_pregross' || element.field_key == 'conveyance_allowance_before_pregross' || element.field_key == 'medical_allowance_before_pregross')
					{
						this.pre_gross_flag = 1;
					}

					if(element.displayset == 'tax_policy' && element.value == '1')
					{
						this.tax_policy_flag = true;
					}

				  });
				  /* Added by Sohel ends */
				  this.slabs_and_values=response.data.slabsnvalues;
				  this.taxinfo=response.data.tax;
				  this.adhocfields=response.data.adhocfields;
				  this.adhocheadsnvalues=response.data.adhocheadsnvalues;

				  if( is_taxcard != 'update'){
					this.payslip_loader = false;
				  }



			  }.bind(this));
			},
			getPayslipInfo: function()
			{
				this.payslip_loader = true;
				axios.get(this.$api_url+'/front/payslipinfo/'+this.payslip, {
							params: {
							}
					}).then(function(response){
					this.fdata = response.data.data;
					if(!this.fdata) return; // fix: guard against null response
					this.employee_id = this.fdata.employee_id;
					if(this.fdata.id!='')
					{
					this.fiscal_year=this.fdata.fiscal_year;
					this.employee_id=this.fdata.employee_id;
					this.from_date=this.fdata.from_date;
					this.to_date=this.fdata.to_date;
					this.pay_slip_ref=this.fdata.pay_slip_ref;

					this.getSalaryDataFromDB('no');
					this.pay_slip_name=this.fdata.pay_slip_name;

					}
				}.bind(this));
			},
			download_file(fileURL, fileName) {
				if (!window.ActiveXObject) {
					var save = document.createElement('a');
					save.href = fileURL;
					save.target = '_blank';
					var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
					save.download = fileName || filename;
					if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
							document.location = save.href;
						}else{
							var evt = new MouseEvent('click', {
								'view': window,
								'bubbles': true,
								'cancelable': false
							});
							save.dispatchEvent(evt);
							(window.URL || window.webkitURL).revokeObjectURL(save.href);
						}
			  	}
				else if ( !! window.ActiveXObject && document.execCommand)     {
					var _window = window.open(fileURL, '_blank');
					_window.document.close();
					_window.document.execCommand('SaveAs', true, fileName || fileURL)
					_window.close();
				}
			},

			downloadPaySlip: function(p_slip,f_year,email_file=false,prnt_file=false)
			{
				this.payslip_loader = true;
				var send_file = email_file ? 1: 0;
				const config = {
					headers: { 'Content-Type': 'application/json; charset=utf-8', },
				}
				let r_type = 'blob';
				if(email_file){
					r_type = 'json';
				}
				axios.get(this.$api_url+'/front/payslippdf/'+f_year+'/'+p_slip , {
					params: {
						em_file:  send_file
					},
					headers: config,
					responseType: r_type,
				}).then(function(response){

					this.payslip_loader = false;
					if(response.data){

					if(response.data.download_name)
					this.download_file_name = response.data.download_name;
					else
					this.download_file_name = this.payslip_title;


					if(prnt_file){
								// this.download_file(response.data.file_name,this.download_file_name+'.pdf');
								if(response.data.type =='application/json'){
									let file = new Blob([response.data], {type: 'application/json'});
									const cast = Promise.resolve(file.text());
									cast.then((value) => {
										let err_obj = JSON.parse(`${value}`);
										this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
									});
								}else{
									this.global_download_file_content(response);
								}
							}
					else if(email_file){
						if(response.data.success)
						this.$bvToast.toast(response.data.success, {
										title: 'Success',
											variant: 'success',
											solid: true
										});
						else if(response.data.error)
						this.$bvToast.toast(response.data.error, {
										title: 'Error!',
											variant: 'danger',
											solid: true
										});
					}
					else{
							// this.download_file(response.data.file_name,this.download_file_name+'.pdf');
							if(response.data.type =='application/json'){
								let file = new Blob([response.data], {type: 'application/json'});
								const cast = Promise.resolve(file.text());
								cast.then((value) => {
									let err_obj = JSON.parse(`${value}`);
									this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
								});
							}else{
								this.global_download_file_content(response);
							}
							}
					}
					else if(response.data.error){
						this.$bvToast.toast(response.data.error, {
										title: 'Error!',
											variant: 'danger',
											solid: true
										});
					}else{
						this.$bvToast.toast('Unexpected server error!', {
										title: 'Error!',
											variant: 'danger',
											solid: true
										});
					}
					//console.log(response.data.file_name);
				}.bind(this));
			},
			formSubmit(e) {
				e.preventDefault();
			}
	  },
	  created: function(){
		 this.getPayslipInfo();
		 this.getFiscalyears();
	  }
  }
</script>